import { memo } from 'react'

interface PaymentModalProps {
  children: React.ReactNode
  isOpen?: boolean
}

const PaymentModal = ({ isOpen, children }: PaymentModalProps) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[600px] rounded-lg bg-white shadow-lg md:w-fit">{children}</div>
    </div>
  )
}

function arePropsEqual(prevProps: PaymentModalProps, nextProps: PaymentModalProps) {
  return prevProps.isOpen === nextProps.isOpen && prevProps.children === nextProps.children
}

export default memo(PaymentModal, arePropsEqual)
